import { getTranslatedKey } from '../../../../../../Utils/TranslateUtils';
import { displayComponents } from '../../../../../../Utils/VisorsUtils';
import { DeleteMapButton, MapTitle, UserMapWrapper } from '../DownloadLoadElement';

export const MapItem = ({ map, onHover, onLeave, hovered, onClick, deleteUserMap, overWriteMap, isUserMap }) => (
  <UserMapWrapper>
    <MapTitle onMouseEnter={onHover} onMouseLeave={onLeave} hovered={hovered} title={map.nom} onClick={onClick}>
      {map.nom}
    </MapTitle>
    {hovered && (
      <>
        {isUserMap && (
          <>
            <DeleteMapButton title={getTranslatedKey('replaceTooltip')} onClick={overWriteMap} onMouseEnter={onHover} onMouseLeave={onLeave}>
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" width="18" fill="#febf00" viewBox="0 0 512 512">
                <g>
                  <path d="M325,174.1H137.9c-7,0-11.7-4.7-11.7-11.7v-117c0-7,4.7-11.7,11.7-11.7H325c7,0,11.7,4.7,11.7,11.7v117   C336.7,169.4,332,174.1,325,174.1z M149.6,150.7h163.7V57.2H149.6V150.7z"></path>
                  <path d="M444.3,478.2h-379c-18.7,0-32.7-14-32.7-32.7v-379c0-18.7,14-32.7,32.7-32.7h292.4c7,0,16.4,2.3,25.7,9.4l86.6,93.6   l2.3,2.3c2.3,4.7,7,11.7,7,18.7v285.4C477.1,464.2,463,478.2,444.3,478.2z M65.3,57.2c-4.7,0-9.4,4.7-9.4,9.4v379   c0,4.7,4.7,9.4,9.4,9.4h379c4.7,0,9.4-4.7,9.4-9.4V160.1c0-2.3-2.3-4.7-2.3-7l-86.6-91.2c-2.3-2.3-7-4.6-7-4.6H65.3V57.2z"></path>
                </g>
              </svg>
            </DeleteMapButton>
            <DeleteMapButton title={getTranslatedKey('deleteMapTooltip')} onClick={deleteUserMap} onMouseEnter={onHover} onMouseLeave={onLeave}>
              <svg viewBox="0 0 24 24" fill="#febf00" xmlns="http://www.w3.org/2000/svg" version="1.1" width="18" class="sc-hgRfpC">
                <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
              </svg>
            </DeleteMapButton>
          </>
        )}
      </>
    )}
  </UserMapWrapper>
);
